/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class DataParameterListEditor extends Common.GridEditorBase<DataParameter> {
        protected getColumnsKey() { return DataParameterListColumns.columnsKey };
        protected getDialogType() { return DataParameterDialog; }

        protected getAddButtonCaption() {
            return "Add Parameter";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            buttons.push({
                title: 'Update Parameters',
                cssClass: 'update-parameters-button',
                icon: 'fa-refresh',
                onClick: () => this.updateParameters && this.updateParameters()
            });

            return buttons;
        }

        public updateParameters: () => void;

        validateEntity(row: DataParameter, id) {

            row.Type = Q.toId(row.Type);
            var sameParameter = Q.tryFirst(this.view.getItems(), x => x.Name === row.Name);
            if (sameParameter && this.id(sameParameter) !== id) {
                Q.alert('This parameter is already in parameter list!');
                return false;
            }
            row.EditorType = Q.trimToNull(row.EditorType);
            return true;
        }
    }
}